import { CardFaceData } from '../../../global-types';

/**
 * Gets WAM Image position, which varies based on card orientation and split-panel side.
 * Pure geometry helper: the caller is responsible for selecting which face to position on.
 * @param {Pick<CardFaceData, 'dimensions' | 'type'>} cardFace - the target card face to center WAM on
 * @returns {object} - Object containing top, left, width and height values
 */
export const getPodWamPosition = (
  cardFace: Pick<CardFaceData, 'dimensions' | 'type'>,
): { wamTop: number; wamLeft: number; wamWidth: number; wamHeight: number } => {
  let topPosition, leftPosition;
  const { dimensions, type } = cardFace;
  const CENTER_OFFSET = 175; // Half of WAM image width/height
  if (dimensions.height > dimensions.width) {
    // Portrait-oriented card, WAM image is centered on the active inside top/bottom panel
    // To center, we offset by half of POD WAM width/height, as top and left represent the top left corner of the image
    topPosition = dimensions.height * (type === 'inside-bottom' ? 0.75 : 0.25) - CENTER_OFFSET;
    leftPosition = dimensions.width * 0.5 - CENTER_OFFSET; // Horizontal center is 50% of width
  } else {
    // Landscape-oriented card, WAM image is centered on the active inside left/right panel
    // To center, we offset by half of POD WAM width/height, as top and left represent the top left corner of the image
    topPosition = dimensions.height * 0.5 - CENTER_OFFSET; // Vertical center is 50% of height
    leftPosition = dimensions.width * (type === 'inside-right' ? 0.75 : 0.25) - CENTER_OFFSET;
  }
  return {
    wamTop: topPosition,
    wamLeft: leftPosition,
    wamWidth: 350,
    wamHeight: 350,
  };
};
